import { CSSObject, styled } from '@mui/material';
import { APIProps } from '@stoplight/elements';
import { FC } from 'react';
import { HEADER_HEIGHT } from '../../layout';
import { twoScrollBarsLayout } from './stoplight-elements-customization/two-scroll-bars-layout';

// imports below have side-effects, order is important
import './stoplight-elements-customization/listeners';

import './stoplight-elements-customization/TryItPanel-maximizable';
import './stoplight-elements-customization/TryItPanel-maximizable.css';

import { configureStoreFields } from './stoplight-elements-customization/TryItPanel-store-fields';

// load stoplight elements after the customizations
import '@stoplight/elements/styles.min.css';
import '@stoplight/elements/web-components.min.js';

interface StoplightElementsProps {
  options: APIProps;
  storeFields?: string[];
  styles: CSSObject;
}

export const StoplightElements: FC<StoplightElementsProps> = ({ options, storeFields, styles }) => {
  if (storeFields) {
    configureStoreFields(storeFields);
  }

  return (
    <Container styles={styles}>
      <elements-api {...options} />
    </Container>
  );
};

const Container = styled('div')<{ styles: CSSObject }>(({ styles }) => ({
  '--header-height': `${HEADER_HEIGHT}px`, // Used in customization
  ...twoScrollBarsLayout,
  '& elements-api': {
    ...twoScrollBarsLayout.elements,
    ...styles
  }
}));

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'elements-api': APIProps;
    }
  }
}
